// just checks if the error has code property
import { isError } from 'lodash';

export default function getFirebaseErrorCode(error: unknown): string {
  if (isError(error) && 'code' in error) {
    return error.code;
  }
  return '';
}
